export const USER_PERMISSION = {
  CATEGORY_MANAGEMENT: 'CATEGORY_MANAGEMENT',
  ARTIST_MANAGEMENT: 'ARTIST_MANAGEMENT',
  GETS_CATEGORY: 'GETS_CATEGORY',
  CREATE_CATEGORY: 'CREATE_CATEGORY',
  UPDATE_CATEGORY: 'UPDATE_CATEGORY',
  DELETE_CATEGORY: 'DELETE_CATEGORY',
  GETS_ARTIST: 'GETS_ARTIST',
  CREATE_ARTIST: 'CREATE_ARTIST',
  UPDATE_ARTIST: 'UPDATE_ARTIST',
  DELETE_ARTIST: 'DELETE_ARTIST',
  CREATE_SONG: 'CREATE_SONG',
  UPDATE_SONG: 'UPDATE_SONG',
  UPDATE_STATUS_SONG: 'UPDATE_STATUS_SONG',
  RECEIVE_SONG_WORKFLOW: 'RECEIVE_SONG_WORKFLOW',
  GETS_SONG: 'GETS_SONG',
  ASSIGN_ROLE: 'ASSIGN_ROLE',
  GETS_ROLE: 'GETS_ROLE',
  UPDATE_ROLE: 'UPDATE_ROLE',
  CREATE_ROLE: 'CREATE_ROLE',
  LOCK_USER: 'LOCK_USER',
  DELETE_USER: 'DELETE_USER',
  UPDATE_USER: 'UPDATE_USER',
  CREATE_USER: 'CREATE_USER',
  GETS_USER: 'GETS_USER',
  UPDATE_PERMISSION: 'UPDATE_PERMISSION',
  CREATE_RESOURCE: 'CREATE_RESOURCE',
  UPDATE_RESOURCE: 'UPDATE_RESOURCE',
  GETS_RESOURCE: 'GETS_RESOURCE',
  GETS_SHORT_VIDEO: 'GETS_SHORT_VIDEO',
  CREATE_SHORT_VIDEO: 'CREATE_SHORT_VIDEO',
  UPDATE_SHORT_VIDEO: 'UPDATE_SHORT_VIDEO',
  UPDATE_STATUS_SHORT_VIDEO: 'UPDATE_STATUS_SHORT_VIDEO',
  RECEIVE_SHORT_VIDEO_WORKFLOW: 'RECEIVE_SHORT_VIDEO_WORKFLOW',
  UPDATE_ALBUM_PLAYLIST: 'UPDATE_ALBUM_PLAYLIST',
  CREATE_ALBUM_PLAYLIST: 'CREATE_ALBUM_PLAYLIST',
  GET_ALBUM_PLAYLIST: 'GET_ALBUM_PLAYLIST',
  CHANGE_STATUS_SHORT_VIDEO: 'CHANGE_STATUS_SHORT_VIDEO',
  CHANGE_STATUS_SONGS: 'CHANGE_STATUS_SONGS',
  TRANSACTION_MANAGEMENT: 'TRANSACTION_MANAGEMENT',
  GETS_TRANSACTION: 'GETS_TRANSACTION',
  EXPORT_TRANSACTION: 'EXPORT_TRANSACTION',
  UPGRADE_MEMBERSHIP_HISTORY_MANAGEMENT:
    'UPGRADE_MEMBERSHIP_HISTORY_MANAGEMENT',
  GETS_MEMBERSHIP_HISTORY: 'GETS_MEMBERSHIP_HISTORY',
  UPGRADE_MEMBERSHIP_HISTORY: 'UPGRADE_MEMBERSHIP_HISTORY',
};
